<template>
  <div class="table-responsive">
    <table class="table mt-5">
      <thead>
        <tr>
          <th>Typ</th>

          <th v-if="withAmount">Kwota</th>

          <th>Początek obowiązywania</th>

          <th>Koniec obowiązywania</th>

          <th>
            <span class="sr-only">Akcje</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, rowIndex) of model.$items" :key="'row_' + rowIndex">
          <td>
            <w-select title tooltip-content :model="item.$item.type" :values="types" />
          </td>

          <td v-if="withAmount">
            <w-input title type="number" :model="item.$item.amount" />
          </td>

          <td>
            <w-datepicker title :model="item.$item.startDate" />
          </td>

          <td>
            <w-datepicker title :model="item.$item.endDate" />
          </td>

          <w-row-buttons
            class="middle"
            :model="item.$item"
            :move-up="rowIndex != 0"
            :move-down="item.$item.$parent.$value.length - 1 !== rowIndex"
          />
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="100%">
            <w-add-row class="btn-primary float-right" :model="model">Dodaj zakres dat</w-add-row>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Komponent wyświetlający zakresy dat decyzji
// @group Decision
export default {
  components,
  props: {
    // Model listy zakresów
    model: { type: Object, fieldRequired: true },
    // Typy przedziałów
    types: { type: Array, fieldRequired: true },
    // Czy wyświetlać kolumnę z kwotą
    withAmount: { type: Boolean, default: true }
  }
};
</script>
